import React, { useRef, useState } from 'react';
import UndoIcon from '@mui/icons-material/Undo';
import Button from '@mui/material/Button';
import { Confirm, useNotify, useRefresh, useUpdate } from 'react-admin';
import { useQueryClient } from 'react-query';

const CustomUndoButton = ({ record, resource, title, onSourceFull, onRestoreSuccess }: {
    record: any;
    resource: string;
    title: string;
    onSourceFull?: () => void;
    onRestoreSuccess?: () => void;
}) => {
    const [open, setOpen] = useState(false);
    const [isRestoring, setIsRestoring] = useState(false);
    const [update, { isLoading }] = useUpdate();
    const queryClient = useQueryClient();
    const refresh = useRefresh()
    const notify = useNotify();
    const restoreInFlightRef = useRef(false);
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = async () => {
        if (restoreInFlightRef.current || isRestoring || isLoading) {
            return;
        }
        restoreInFlightRef.current = true;
        setIsRestoring(true);
        update(
            'deletedDocument',
            { id: record?.id, data: { ...record }, previousData: record },{
                mutationMode: "pessimistic",
                onError:(error: any)=>{
                    const message:any=error;
                     if (error?.code === 'DOCUMENT_RESTORE_SOURCE_FULL') {
                                handleDialogClose();
                        onSourceFull?.();
                     }
                     notify(`${message.message}`, { type: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' }})
                },
                onSuccess:()=>{
                    queryClient.invalidateQueries(['deletedDocument']);
                    refresh();
                    handleDialogClose();
                    onRestoreSuccess?.();
                },
                onSettled:()=>{
                    restoreInFlightRef.current = false;
                    setIsRestoring(false);
                }
            }
        )
        // .then(_ => {
        //     refresh();
        // }).catch(err => {
        //     
        //     // refresh();
        // }).finally(() => handleDialogClose())
    };

    return (
        <>
            <Confirm
                isOpen={open}
                loading={isLoading || isRestoring}
                title={title}
                content={`Are you sure you want to Restore this item?`}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
            <Button
                size="small"
                variant='contained'
                startIcon={<UndoIcon />}
                disabled={isLoading || isRestoring}
                onClick={() => handleClick()}

            >Restore</Button>
        </>
    );
}

export default CustomUndoButton;
